module.exports = __webpack_public_path__ + "img/93.519b9149.jpg";